import {
	ApButtonMain,
	ApButtonText,
	ApIcon,
	colors,
} from '@alixpartners/ui-components';
import { ApSignalrConsumer, Telemetry } from '@alixpartners/ui-utils';
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import {
	ButtonWrapper,
	DescriptionText,
	DropWrapper,
	DropZoneArea,
	DropZoneText,
	IconWrapper,
	RefreshStatusBlock,
} from './styles';
import {
	cleanSkuState,
	executeSkuPipeline,
	validateSkuFile,
} from 'utils/apiRequests';
import UploadProgressBar from 'Data/components/UploadProgressBar';
import { getStatusMessage } from './utils';
import { SKU_UPLOAD_STATUS } from 'Data/constants';
import ErrorList from 'Data/components/ErrorList';

const errorPoints = [
	SKU_UPLOAD_STATUS.ERRORSTATE,
	SKU_UPLOAD_STATUS.SKUDATAUPLOADFAILED,
	SKU_UPLOAD_STATUS.SKUDATAVALIDATIONFAILED,
];
class index extends React.Component {
	static propTypes = {
		status: PropTypes.object.isRequired,
		refetchSkuState: PropTypes.func.isRequired,
		fetchFileArchive: PropTypes.func.isRequired,
	};

	dropzoneRef = React.createRef();

	state = {
		statusMessage: '',
		status: this.props.status,
		errors: this.props.status.errors || [],
		currentSkuStep: this.props.status.state,
		refetchSkuState: this.props.refetchSkuState,
		totalSkuSteps: 8,
		isProcessing:
			this.props.status.state !== SKU_UPLOAD_STATUS.NO_DATA &&
			(!this.props.status.errors || this.props.status.errors.length === 0),
		isAnyErrorOccured: errorPoints.includes(this.props.status.state),
	};
	componentDidMount() {
		const { status } = this.props;
		// console.log(status);
		if (status.state === 1) {
			const currentProgressMessage = getStatusMessage(Number(status.state));
			this.setState({
				statusMessage: currentProgressMessage,
				currentSkuStep: status.state,
				isProcessing: this.props.status.state !== SKU_UPLOAD_STATUS.NO_DATA,
			});
		} else if (typeof status.state === 'number') {
			const currentProgressMessage = getStatusMessage(Number(status.state));
			this.setState({
				isProcessing: true,
				currentSkuStep: status.state,
				statusMessage: currentProgressMessage,
			});
		}
		if (Number(status.errorLogFiles)) {
			this.fetchFileAndCleanup();
		}
		if (
			Number(status.state) === 8 ||
			Number(status.state) === SKU_UPLOAD_STATUS.ERRORSTATE ||
			Number(status.state) === SKU_UPLOAD_STATUS.SKUDATAUPLOADFAILED ||
			Number(status.state) === SKU_UPLOAD_STATUS.SKUDATAVALIDATIONFAILED
		) {
			this.fetchFileAndCleanup();
		}
	}
	fetchFileAndCleanup() {
		const { fetchFileArchive, refetchSkuState } = this.props;
		const { status } = this.props;
		console.log(status);
		this.setState(
			{
				statusMessage: getStatusMessage(Number(status.state)),
				currentSkuStep: 8,
				totalSkuSteps: 8,
			},
			() => {
				fetchFileArchive();
				cleanSkuState().then(() => {
					refetchSkuState();
				});
			}
		);
	}

	onFileSelected = async acceptedFiles => {
		const file = acceptedFiles[0];
		const currentProgressMessage = getStatusMessage(
			Number(this.props.status.state)
		);

		this.setState(
			{
				isProcessing: true,
				currentSkuStep: this.props.status.state,
				statusMessage: currentProgressMessage,
			},
			() => {
				validateSkuFile(file)
					.then(({ id, url, validationResponse }) => {
						const isValid =
							!validationResponse.errors ||
							validationResponse.errors.length === 0;
						if (isValid) {
							executeSkuPipeline(id, url)
								.then(response => {
									this.setState({
										currentSkuStep: response.state,
										totalSkuSteps: 8,
									});
								})
								.catch(() => {
									this.setState({
										currentSkuStep: SKU_UPLOAD_STATUS.PIPELINEFAILED,
										isProcessing: false,
									});
								});
						} else {
							this.setState({
								currentSkuStep: SKU_UPLOAD_STATUS.VALIDATIONFAILED,
								errors: validationResponse.errors,
								isProcessing: false,
								totalSkuSteps: 8,
							});
						}
					})
					.catch(() => {
						this.setState({
							currentSkuStep: SKU_UPLOAD_STATUS.VALIDATIONFAILED,
							isProcessing: false,
						});
					});
			}
		);
		Telemetry.trackEvent('file selected');
	};

	restartUploading() {
		const { refetchSkuState } = this.props;
		cleanSkuState().then(() =>
			this.setState(
				{
					currentSkuStep: SKU_UPLOAD_STATUS.NO_DATA,
					errors: [],
					isProcessing: false,
				},
				() => refetchSkuState()
			)
		);
	}

	renderInitialBlock = () => {
		Telemetry.trackEvent('showing upload file');

		return (
			<React.Fragment>
				<IconWrapper>
					<ApIcon
						iconName="cloud_upload"
						iconSize="96px"
						iconColor={colors.grey3}
					/>
				</IconWrapper>
				<DropZoneText>
					<DescriptionText>
						Drag <span>.csv</span> file here or browse files to upload
					</DescriptionText>
					<ButtonWrapper>
						<ApButtonMain iconName="baseline_add">Add file</ApButtonMain>
					</ButtonWrapper>
				</DropZoneText>
			</React.Fragment>
		);
	};

	renderProcessingBlock = () => {
		const {
			errors,
			statusMessage,
			currentSkuStep,
			totalSkuSteps,
			refetchSkuState,
		} = this.state;

		return (
			<>
				<UploadProgressBar
					label={statusMessage}
					value={Math.floor((100 * currentSkuStep) / totalSkuSteps)}
				/>

				<ApSignalrConsumer
					message="SKUDataPipelineInProgress"
					onMessage={(
						messageKey,
						statusMessage,
						currentSkuStep,
						totalSkuSteps
					) => {
						if (
							Number(currentSkuStep) === 8 ||
							errorPoints.includes(Number(currentSkuStep))
						) {
							this.restartUploading();
							// this.fetchFileAndCleanup();
						} else {
							this.setState(
								{
									statusMessage: statusMessage,
									currentSkuStep: Number(currentSkuStep),
									totalSkuSteps: Number(totalSkuSteps),
									isProcessing: errors?.length === 0,
								},
								() => {
									// this.fetchFileAndCleanup();
									refetchSkuState();
								}
							);
						}
					}}
				/>
				<ApSignalrConsumer
					message="SKUDataPipelineFailed"
					onMessage={(
						messageKey,
						statusMessage,
						currentSkuStep,
						totalSkuSteps
					) => {
						console.log(currentSkuStep);
						if (Number(currentSkuStep) === 99) {
							console.log('error in pipeline');

							this.restartUploading();
						}
					}}
				/>
				<ApSignalrConsumer
					message="SKUDataValidationFailed"
					onMessage={() => {
						console.log('Validation Failed');
						this.fetchFileAndCleanup();
					}}
				/>
				<ApSignalrConsumer
					message="SKUDataUploadFailed"
					onMessage={() => {
						console.log('Upload failed');
						this.fetchFileAndCleanup();
						refetchSkuState();
					}}
				/>
			</>
		);
	};

	render() {
		const { isProcessing, errors, currentSkuStep } = this.state;
		const { fileName, fileSize, rowsWithErrors } = this.props.status;

		if (isProcessing) {
			return this.renderProcessingBlock();
		}

		return (
			<React.Fragment>
				{currentSkuStep === SKU_UPLOAD_STATUS.NO_DATA && (
					<Dropzone
						ref={this.dropzoneRef}
						onDrop={this.onFileSelected}
						style={{}}
						noKeyboard
					>
						{({ getRootProps, getInputProps }) => (
							<DropWrapper {...getRootProps()}>
								<input {...getInputProps()} />
								<DropZoneArea>
									<React.Fragment>{this.renderInitialBlock()}</React.Fragment>
								</DropZoneArea>
							</DropWrapper>
						)}
					</Dropzone>
				)}
				{errors !== null &&
					errors.length > 0 && (
						<>
							<RefreshStatusBlock>
								<ApButtonText onClick={() => this.restartUploading()}>
									Restart Uploading
								</ApButtonText>
							</RefreshStatusBlock>
						</>
					)}
				{errors !== null &&
					errors.length > 0 && (
						<ErrorList
							rowsWithErrors={rowsWithErrors}
							errors={errors}
							fileSize={fileSize}
							fileName={fileName}
						/>
					)}
			</React.Fragment>
		);
	}
}

export default index;
